"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const NOTIFY_PARAM = 'notify_open';
function onLoad() {
    return __awaiter(this, void 0, void 0, function* () {
        const redirectButton = document.getElementById('klaviyo-notify-redirect');
        const klaviyoButton = document.getElementById('klaviyo-trigger-notify-open');
        if (redirectButton) {
            redirectButton.style.display = 'none';
            klaviyoButton.style.display = 'flex';
        }
    });
}
function onLoadClick() {
    return __awaiter(this, void 0, void 0, function* () {
        const klaviyoButton = document.getElementById('klaviyo-trigger-notify-open');
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has(NOTIFY_PARAM) && searchParams.get(NOTIFY_PARAM)) {
            klaviyoButton.click();
        }
    });
}
window.addEventListener('load', onLoadClick);
document.addEventListener('DOMContentLoaded', onLoad);
